<template>
  <div class="contact-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增联系人
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.data.status===1?'禁用':'启用'"
            :alert-title="record.data.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
      <contact-modal
        ref="contactModalForm"
        :title="title"
        :visible="visible"
        @onCancel="onCancel"
      >
        <form-button
          :btn-is-loading="btnIsLoading"
          @onCancel="onCancel"
          @onSubmit="onSubmit"
        />
      </contact-modal>
    </div>
  </div>
</template>
<script>
import {contactColumns} from '../data/index';
import contactModal from '../modal/contactModal';
export default {
  components: { contactModal},
  data() {
    return {
      columns: contactColumns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      title: '',
      type: '',
      btnIsLoading: false,
      visible: false,
      customer_id: '',
      id: '',
    };
  },
  mounted() {
    this.customer_id=this.$route.query.id;
    // 获取表格数据
    this.getTableData({page: this.current, pageSize: this.pageSize, customer_id: this.customer_id});
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading=true;
      let result = await this.$http.post('/Contact/getList', params);
      if (result.data.status===1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            name: item.real_name,
            phone: item.phone,
            sex: item.sex,
            province: item.province_txt,
            city: item.city_txt,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;

      }
    },
    // 编辑或新增
    editAndAdd(record) {
      console.log('TCL: editAndAdd -> record', record);
      this.visible = true;
      if (!record.id) {
        // 新增
        this.id='';
        this.title = '新增联系人';
        this.$nextTick(() => {
          this.$refs.contactModalForm.$refs.basicForm.form.resetFields();
        });
      } else {
        // 编辑
        this.title = '编辑联系人';
        let data={
          company_id: record.data.company_id,
          real_name: record.data.real_name,
          sex: record.data.sex,
          provinceCity: {province: Number(record.data.province), city: Number(record.data.city)},
          phone: record.data.phone,
          address: record.data.address,
        };
        console.log('data', data);
        this.id=record.id;
        this.$nextTick(() => {
          this.$refs.contactModalForm.$refs.basicForm.form.setFieldsValue(
            data,
          );
        });
      }
    },
    // 确定编辑或新增
    onSubmit() {
      console.log(2222);
      this.$refs.contactModalForm.$refs.basicForm.form.validateFields(
        async(err, values) => {
          console.log('TCL: onSubmit -> values', values);
          if (!err) {
            console.log(values);
            values.province=values.provinceCity.province;
            values.city=values.provinceCity.city;
            values.path=`0,${values.provinceCity.province},${values.provinceCity.city}`;
            this.btnIsLoading=true;

            let result=await this.$http.post('/Contact/update', { id: this.id, customer_id: this.customer_id, ...values});
            this.btnIsLoading=false;
            if(result.data.status===1){
              this.$message.success('操作成功！');
              this.getTableData({page: this.current, pageSize: this.pageSize, customer_id: this.customer_id});
              this.visible = false;
            }
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },

    // 禁用 启用
    async onConfirm(record) {
      console.log('TCL: onConfirm -> record', record);
      let result=await this.$http.post('/Customer/setStatus', {id: record.id, status: record.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({page: this.current, pageSize: this.pageSize, customer_id: this.customer_id});
      }
    },
    // 删除
    async onDelete(record) {
      let result=await this.$http.post('/Customer/setStatus', {id: record.id, status: -1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({page: this.current, pageSize: this.pageSize, customer_id: this.customer_id});
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({page: this.current, pageSize: this.pageSize, customer_id: this.customer_id});
    },
  },
};
</script>
<style lang="scss" scoped>
.contact-container {
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}
</style>
